import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

export default function HomePage() {
  const { t, i18n } = useTranslation();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const isRTL = i18n.language === 'ar';

  useEffect(() => {
    document.documentElement.dir = isRTL ? 'rtl' : 'ltr';
    document.documentElement.lang = i18n.language;
  }, [isRTL, i18n.language]);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  const changeLanguage = (lng: string) => {
    i18n.changeLanguage(lng);
  };

  return (
    <div className= "bg-gray-50 min-h-screen" >
    {/* Header */ }
    <header className = {`sticky top-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white shadow-sm' : 'bg-transparent'}`
}>
  <div className="container mx-auto px-4 py-4 flex items-center justify-between" >
    <div className="flex items-center" >
      <img src="https://5vix.com/logo.png" alt = "5vix Logo" className = "h-10 w-10" />
        </div>

        <nav className = "hidden md:flex items-center space-x-8 rtl:space-x-reverse" >
          <a href="#home" className = "text-gray-800 hover:text-purple-600 transition-colors" > { t('nav.home') } </a>
            <a href = "#services" className = "text-gray-800 hover:text-purple-600 transition-colors" > { t('nav.services') } </a>
              <a href = "#register" className = "text-gray-800 hover:text-purple-600 transition-colors" > { t('nav.register') } </a>
                <a href = "#blog" className = "text-gray-800 hover:text-purple-600 transition-colors" > { t('nav.blog') } </a>
                  </nav>

                  <div className = "flex items-center gap-4" >
                    <button 
              onClick={ () => changeLanguage(i18n.language === 'en' ? 'ar' : 'en') }
className = "px-4 py-2 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200 transition-all whitespace-nowrap cursor-pointer font-medium"
  >
  { i18n.language === 'en' ? 'ع' : 'EN' }
  </button>
  <a href = "#register" className = "bg-purple-600 text-white px-6 py-2 rounded-lg hover:bg-purple-700 transition-all whitespace-nowrap cursor-pointer" >
    { t('nav.tryFree') }
    </a>
    <button onClick = { toggleMobileMenu } className = "md:hidden w-10 h-10 flex items-center justify-center text-gray-700 cursor-pointer" >
      <i className="ri-menu-line text-xl" > </i>
        </button>
        </div>
        </div>
        </header>

{/* Mobile Menu */ }
{
  mobileMenuOpen && (
    <div className="fixed inset-0 z-40 md:hidden" >
      <div className="absolute inset-0 bg-black bg-opacity-50" onClick = { toggleMobileMenu } > </div>
        <div className = {`absolute ${isRTL ? 'left-0' : 'right-0'} top-0 w-64 h-full bg-white shadow-lg p-6`
}>
  <button onClick={ toggleMobileMenu } className = "mb-6 text-gray-700 font-medium cursor-pointer" > Close </button>
    <nav className = "flex flex-col space-y-4" >
      <a href="#home" className = "text-gray-800 hover:text-purple-600" onClick = { toggleMobileMenu } > { t('nav.home') } </a>
        <a href = "#services" className = "text-gray-800 hover:text-purple-600" onClick = { toggleMobileMenu } > { t('nav.services') } </a>
          <a href = "#register" className = "text-gray-800 hover:text-purple-600" onClick = { toggleMobileMenu } > { t('nav.register') } </a>
            <a href = "#blog" className = "text-gray-800 hover:text-purple-600" onClick = { toggleMobileMenu } > { t('nav.blog') } </a>
              </nav>
              </div>
              </div>
      )}

{/* Hero Section */ }
<section id="home" className = "relative py-20 overflow-hidden bg-gradient-to-br from-purple-50 to-blue-50" >
  <div className="container mx-auto px-4 relative z-10" >
    <div className="flex flex-col md:flex-row items-center gap-12" >
      <div className="w-full md:w-1/2" >
        <h1 className="text-4xl md:text-5xl font-bold mb-6 text-gray-900" >
          <span className="block mb-2" > { t('hero.title1') } </span>
            <span className = "text-purple-600" > { t('hero.title2') } </span>
              </h1>
              <p className = "text-lg text-gray-700 mb-8" >
                { t('hero.description') }
                </p>
                <div className = "flex flex-col sm:flex-row gap-4" >
                  <a href="#register" className = "bg-purple-600 text-white px-8 py-3 rounded-lg hover:bg-purple-700 transition-all text-center whitespace-nowrap cursor-pointer" >
                    { t('hero.tryFree') }
                    </a>
                    <a href = "#demo" className = "border border-purple-600 text-purple-600 px-8 py-3 rounded-lg hover:bg-purple-600 hover:text-white transition-all text-center whitespace-nowrap cursor-pointer" >
                      { t('hero.requestDemo') }
                      </a>
                      </div>
                      </div>

                      <div className = "w-full md:w-1/2" >
                        <div className="bg-white rounded-xl shadow-lg p-6" >
                          <div className="flex items-center justify-between mb-8" >
                            <div>
                            <h2 className="text-2xl font-bold text-gray-900" > 86,000 </h2>
                              <p className = "text-gray-600" > { t('hero.revenue') } </p>
                                </div>
                                <div className = "text-red-500 text-sm font-bold" >
                                  -71.0 % <span className="text-gray-500" > { t('hero.fromLastMonth') } </span>
                                    </div>
                                    </div>

                                    <div className = "grid grid-cols-2 gap-6 mb-8" >
                                      <div>
                                      <h3 className="text-lg font-semibold text-gray-900" > 952 </h3>
                                        <p className = "text-gray-600" > { t('hero.totalMemberships') } </p>
                                          <div className = "mt-2" >
                                            <div className="flex justify-between text-sm mb-1" >
                                              <span>{ t('hero.active') }: 520 </span>
                                                <span > { t('hero.inactive') }: 432 </span>
                                                  </div>
                                                  <div className = "h-2 bg-gray-200 rounded-full" >
                                                    <div className="h-2 bg-purple-600 rounded-full" style = {{ width: '55%' }}> </div>
                                                      </div>
                                                      </div>
                                                      </div>

                                                      <div >
                                                      <h3 className="text-lg font-semibold text-gray-900" > 26 </h3>
                                                        <p className = "text-gray-600" > { t('hero.newMemberships') } </p>
                                                          <div className = "flex items-center gap-4 mt-2" >
                                                            <div className="flex -space-x-2 rtl:space-x-reverse" >
                                                              <div className="w-8 h-8 rounded-full bg-purple-100 flex items-center justify-center text-purple-600" >
                                                                <i className="ri-user-add-line" > </i>
                                                                  </div>
                                                                  <div className = "w-8 h-8 rounded-full bg-purple-100 flex items-center justify-center text-purple-600" >
                                                                    <i className="ri-user-add-line" > </i>
                                                                      </div>
                                                                      </div>
                                                                      <span className = "text-sm text-gray-500" > { t('hero.thisMonth') } </span>
                                                                        </div>
                                                                        </div>
                                                                        </div>

                                                                        <div className = "relative h-32" >
                                                                          <div className="absolute inset-0 flex items-end justify-between gap-2" >
                                                                          {
                                                                            [40, 60, 50, 70, 45, 80, 55].map((height, index) => (
                                                                              <div key= { index } className = "flex-1 bg-purple-100 rounded-t-lg" style = {{ height: `${height}%` }} > </div>
                    ))}
</div>
  </div>
  </div>
  </div>
  </div>
  </div>
  </section>

{/* Why Choose Section */ }
<section className="py-16 bg-white" >
  <div className="container mx-auto px-4" >
    <div className="text-center mb-16" >
      <h2 className="text-3xl font-bold mb-4" > { t('whyChoose.title') } </h2>
        <p className = "text-gray-600 max-w-2xl mx-auto" >
          { t('whyChoose.description') }
          </p>
          </div>

          <div className = "grid grid-cols-1 md:grid-cols-3 gap-8" >
            <div className="bg-white p-6 rounded-lg shadow-md hover:shadow-xl transition-shadow" >
              <div className="w-16 h-16 bg-purple-100 rounded-full flex items-center justify-center mb-4 mx-auto" >
                <i className="ri-time-line text-purple-600 text-2xl" > </i>
                  </div>
                  <h3 className = "text-xl font-semibold text-center mb-3" > { t('whyChoose.timeSaving') } </h3>
                    <p className = "text-gray-600 text-center" >
                      { t('whyChoose.timeSavingDesc') }
                      </p>
                      </div>

                      <div className = "bg-white p-6 rounded-lg shadow-md hover:shadow-xl transition-shadow" >
                        <div className="w-16 h-16 bg-purple-100 rounded-full flex items-center justify-center mb-4 mx-auto" >
                          <i className="ri-bar-chart-line text-purple-600 text-2xl" > </i>
                            </div>
                            <h3 className = "text-xl font-semibold text-center mb-3" > { t('whyChoose.analytics') } </h3>
                              <p className = "text-gray-600 text-center" >
                                { t('whyChoose.analyticsDesc') }
                                </p>
                                </div>

                                <div className = "bg-white p-6 rounded-lg shadow-md hover:shadow-xl transition-shadow" >
                                  <div className="w-16 h-16 bg-purple-100 rounded-full flex items-center justify-center mb-4 mx-auto" >
                                    <i className="ri-customer-service-line text-purple-600 text-2xl" > </i>
                                      </div>
                                      <h3 className = "text-xl font-semibold text-center mb-3" > { t('whyChoose.experience') } </h3>
                                        <p className = "text-gray-600 text-center" >
                                          { t('whyChoose.experienceDesc') }
                                          </p>
                                          </div>
                                          </div>
                                          </div>
                                          </section>

{/* Services Section */ }
<section id="services" className = "py-16 bg-gray-50" >
  <div className="container mx-auto px-4" >
    <div className="text-center mb-16" >
      <h2 className="text-3xl font-bold mb-4" > { t('services.title') } </h2>
        <p className = "text-gray-600 max-w-2xl mx-auto" >
          { t('services.description') }
          </p>
          </div>

          <div className = "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" >
          {
            [
            {
              icon: 'ri-user-add-line',
              title: t('services.membership.title'),
              description: t('services.membership.description'),
              features: [
                t('services.membership.feature1'),
                t('services.membership.feature2'),
                t('services.membership.feature3')
              ]
            },
            {
              icon: 'ri-calendar-check-line',
              title: t('services.scheduling.title'),
              description: t('services.scheduling.description'),
              features: [
                t('services.scheduling.feature1'),
                t('services.scheduling.feature2'),
                t('services.scheduling.feature3')
              ]
            },
            {
              icon: 'ri-money-dollar-circle-line',
              title: t('services.payment.title'),
              description: t('services.payment.description'),
              features: [
                t('services.payment.feature1'),
                t('services.payment.feature2'),
                t('services.payment.feature3')
              ]
            },
            {
              icon: 'ri-pie-chart-line',
              title: t('services.analytics.title'),
              description: t('services.analytics.description'),
              features: [
                t('services.analytics.feature1'),
                t('services.analytics.feature2'),
                t('services.analytics.feature3')
              ]
            },
            {
              icon: 'ri-smartphone-line',
              title: t('services.memberApp.title'),
              description: t('services.memberApp.description'),
              features: [
                t('services.memberApp.feature1'),
                t('services.memberApp.feature2'),
                t('services.memberApp.feature3')
              ]
            },
            {
              icon: 'ri-store-line',
              title: t('services.inventory.title'),
              description: t('services.inventory.description'),
              features: [
                t('services.inventory.feature1'),
                t('services.inventory.feature2'),
                t('services.inventory.feature3')
              ]
            }
            ].map((service, index) => (
              <div key= { index } className = "bg-white p-6 rounded-lg shadow-sm hover:shadow-xl transition-shadow" >
              <div className="w-14 h-14 bg-purple-100 rounded-full flex items-center justify-center mb-4" >
            <i className={`${service.icon} text-purple-600 text-xl`} > </i>
            </div>
            <h3 className = "text-xl font-semibold mb-3" > { service.title } </h3>
              <p className = "text-gray-600 mb-4" > { service.description } </p>
                <ul className = "space-y-2" >
                {
                  service.features.map((feature, idx) => (
                    <li key= { idx } className = "flex items-center" >
                    <div className="w-5 h-5 flex items-center justify-center text-purple-600 mr-2 rtl:mr-0 rtl:ml-2" >
                  <i className="ri-check-line" > </i>
                  </div>
                  <span className = "text-gray-700" > { feature } </span>
                  </li>
                  ))
                }
                  </ul>
                  </div>
            ))}
</div>
  </div>
  </section>

{/* Statistics Section */ }
<section className="py-16 bg-white" >
  <div className="container mx-auto px-4" >
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" >
      <div className="bg-white p-6 rounded-lg shadow-sm" >
        <div className="flex items-center justify-between mb-8" >
          <div>
          <h3 className="text-2xl font-bold text-gray-900" > 86,000 </h3>
            <p className = "text-gray-600" > { t('stats.revenue') } </p>
              </div>
              <div className = "text-red-500 text-sm font-bold" >
                -71.0 % <span className="text-gray-500 font-bold" > { t('stats.fromPreviousMonth') } </span>
                  </div>
                  </div>
                  <div className = "relative h-32" >
                    <div className="absolute inset-0 flex items-end justify-between gap-1" >
                    {
                      [30, 45, 35, 60, 40, 70, 50, 55, 45, 65, 50, 60].map((height, index) => (
                        <div key= { index } className = "flex-1 bg-purple-100 rounded-t" style = {{ height: `${height}%` }} > </div>
                  ))}
</div>
  </div>
  </div>

  <div className = "bg-white p-6 rounded-lg shadow-sm" >
    <div className="flex items-center justify-between mb-8" >
      <div>
      <h3 className="text-2xl font-bold text-gray-900" > 9, 600 </h3>
        <p className = "text-gray-600" > { t('stats.netProfit') } </p>
          </div>
          <div className = "flex items-center gap-2" >
            <div className="h-2 w-24 bg-gray-200 rounded-full" >
              <div className="h-2 bg-purple-600 rounded-full" style = {{ width: '65%' }}> </div>
                </div>
                <span className = "text-sm text-gray-500" > 65 % </span>
                  </div>
                  </div>
                  <div className = "space-y-4" >
                    <div className="flex justify-between items-center" >
                      <span className="text-gray-700" > { t('stats.income') } </span>
                        <div className = "flex items-center gap-2" >
                          <div className="h-2 w-32 bg-purple-100 rounded-full" >
                            <div className="h-2 bg-purple-600 rounded-full" style = {{ width: '80%' }}> </div>
                              </div>
                              <span className = "text-sm" > 86,000 </span>
                                </div>
                                </div>
                                <div className = "flex justify-between items-center" >
                                  <span className="text-gray-700" > { t('stats.expenses') } </span>
                                    <div className = "flex items-center gap-2" >
                                      <div className="h-2 w-32 bg-orange-200 rounded-full" >
                                        <div className="h-2 bg-orange-500 rounded-full" style = {{ width: '70%' }}> </div>
                                          </div>
                                          <span className = "text-sm" > 76, 400 </span>
                                            </div>
                                            </div>
                                            </div>
                                            </div>

                                            <div className = "bg-white p-6 rounded-lg shadow-sm" >
                                              <div className="flex items-center justify-between mb-8" >
                                                <div>
                                                <h3 className="text-2xl font-bold text-gray-900" > 952 </h3>
                                                  <p className = "text-gray-600" > { t('stats.members') } </p>
                                                    </div>
                                                    <div className = "flex -space-x-2 rtl:space-x-reverse" >
                                                      <div className="w-8 h-8 rounded-full bg-purple-100 flex items-center justify-center text-purple-600" >
                                                        <i className="ri-user-add-line" > </i>
                                                          </div>
                                                          <div className = "w-8 h-8 rounded-full bg-purple-100 flex items-center justify-center text-purple-600" >
                                                            <i className="ri-user-add-line" > </i>
                                                              </div>
                                                              </div>
                                                              </div>
                                                              <div className = "space-y-4" >
                                                                <div className="flex justify-between text-sm mb-1" >
                                                                  <span className="text-gray-700" > { t('hero.active') }: 520 </span>
                                                                    <span className = "text-gray-700" > { t('hero.inactive') }: 432 </span>
                                                                      </div>
                                                                      <div className = "h-2 bg-gray-200 rounded-full" >
                                                                        <div className="h-2 bg-purple-600 rounded-full" style = {{ width: '55%' }}> </div>
                                                                          </div>
                                                                          <div className = "grid grid-cols-7 gap-2" >
                                                                          {
                                                                            [8, 12, 10, 14, 8, 16, 10].map((height, index) => (
                                                                              <div key= { index } className = {`h-${height} bg-purple-100 rounded`} style = {{ height: `${height * 4}px` }}> </div>
                  ))}
</div>
  </div>
  </div>
  </div>

  <div className = "grid grid-cols-1 md:grid-cols-2 gap-8 mt-8" >
    <div className="bg-white p-6 rounded-lg shadow-sm" >
      <h3 className="text-xl font-semibold mb-6" > { t('stats.organicSources') } </h3>
        <div className = "space-y-4" >
        {
          [
          { label: t('stats.socialMedia'), percentage: '41.4%', value: '22.5K', color: 'bg-blue-500' },
          { label: t('stats.friends'), percentage: '28.7%', value: '20.2K', color: 'bg-green-500' },
          { label: t('stats.directVisit'), percentage: '26.9%', value: '24.1K', color: 'bg-purple-600' },
          { label: t('stats.calls'), percentage: '0.0%', value: '3.9', color: 'bg-gray-300' }
          ].map((source, index) => (
            <div key= { index } className = "flex items-center justify-between" >
            <div className="flex items-center gap-3" >
          <div className={`w-3 h-3 ${source.color} rounded-full`} > </div>
          <span className = "text-gray-700" > { source.label } </span>
            </div>
            <div className = "flex items-center gap-2" >
              <span className="text-gray-900 font-semibold" > { source.percentage } </span>
                <span className = "text-gray-500 text-sm" > { source.value } </span>
                  </div>
                  </div>
                ))}
</div>
  </div>

  <div className = "bg-white p-6 rounded-lg shadow-sm" >
    <h3 className="text-xl font-semibold mb-6" > { t('stats.billingStatus') } </h3>
      <div className = "grid grid-cols-5 gap-4" >
      {
        [
        { label: t('stats.draft'), value: '12' },
        { label: t('stats.sent'), value: '18' },
        { label: t('stats.paid'), value: '45' },
        { label: t('stats.partiallyPaid'), value: '7' },
        { label: t('stats.overdue'), value: '3' }
        ].map((item, index) => (
          <div key= { index } className = "text-center" >
          <div className="w-16 h-16 bg-purple-100 rounded-full flex items-center justify-center mx-auto mb-2" >
        <span className="text-purple-600 font-semibold" > { item.value } </span>
        </div>
        <p className = "text-sm text-gray-600" > { item.label } </p>
        </div>
        ))
      }
        </div>
        </div>
        </div>
        </div>
        </section>

{/* Registration Section */ }
<section id="register" className = "py-16 bg-white" >
  <div className="container mx-auto px-4" >
    <div className="flex flex-col md:flex-row items-center gap-12" >
      <div className="w-full md:w-1/2" >
        <h2 className="text-3xl font-bold mb-6" >
          <span>{ t('register.title1') } </span>
          <span className = "text-purple-600" > { t('register.title2') } </span>
            <span > { t('register.title3') } </span>
            </h2>
            <p className = "text-gray-600 mb-8" >
              { t('register.description') }
              </p>

              <div className = "space-y-6" >
                <div className="flex items-start" >
                  <div className="w-10 h-10 flex items-center justify-center bg-purple-100 rounded-full text-purple-600 mt-1 mr-4 rtl:mr-0 rtl:ml-4" >
                    <i className="ri-rocket-line" > </i>
                      </div>
                      <div >
                      <h3 className="text-lg font-semibold mb-1" > { t('register.quickSetup') } </h3>
                        <p className = "text-gray-600" > { t('register.quickSetupDesc') } </p>
                          </div>
                          </div>

                          <div className = "flex items-start" >
                            <div className="w-10 h-10 flex items-center justify-center bg-purple-100 rounded-full text-purple-600 mt-1 mr-4 rtl:mr-0 rtl:ml-4" >
                              <i className="ri-shield-check-line" > </i>
                                </div>
                                <div >
                                <h3 className="text-lg font-semibold mb-1" > { t('register.dataSafe') } </h3>
                                  <p className = "text-gray-600" > { t('register.dataSafeDesc') } </p>
                                    </div>
                                    </div>

                                    <div className = "flex items-start" >
                                      <div className="w-10 h-10 flex items-center justify-center bg-purple-100 rounded-full text-purple-600 mt-1 mr-4 rtl:mr-0 rtl:ml-4" >
                                        <i className="ri-customer-service-2-line" > </i>
                                          </div>
                                          <div >
                                          <h3 className="text-lg font-semibold mb-1" > { t('register.support') } </h3>
                                            <p className = "text-gray-600" > { t('register.supportDesc') } </p>
                                              </div>
                                              </div>
                                              </div>
                                              </div>

                                              <div className = "w-full md:w-1/2" >
                                                <div className="bg-white p-8 rounded-lg shadow-lg" >
                                                  <h3 className="text-2xl font-bold mb-6" > { t('register.formTitle') } </h3>
                                                    <form className = "space-y-6" >
                                                      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" >
                                                        <div>
                                                        <label htmlFor="firstName" className = "block text-sm font-medium text-gray-700 mb-1" >
                                                          { t('register.firstName') }
                                                          </label>
                                                          <input
type = "text"
id = "firstName"
name = "firstName"
required
className = "w-full px-4 py-2 text-gray-900 bg-gray-100 rounded-md focus:ring-purple-600 focus:border-purple-600"
placeholder = { t('register.firstName') }
  />
  </div>
  <div >
  <label htmlFor="lastName" className = "block text-sm font-medium text-gray-700 mb-1" >
    { t('register.lastName') }
    </label>
    <input
type = "text"
id = "lastName"
name = "lastName"
required
className = "w-full px-4 py-2 text-gray-900 bg-gray-100 rounded-md focus:ring-purple-600 focus:border-purple-600"
placeholder = { t('register.lastName') }
  />
  </div>
  </div>

  <div >
  <label htmlFor="gymName" className = "block text-sm font-medium text-gray-700 mb-1" >
    { t('register.gymName') }
    </label>
    <input
type = "text"
id = "gymName"
name = "gymName"
required
className = "w-full px-4 py-2 text-gray-900 bg-gray-100 rounded-md focus:ring-purple-600 focus:border-purple-600"
placeholder = { t('register.gymName') }
  />
  </div>

  <div className = "grid grid-cols-1 sm:grid-cols-2 gap-4" >
    <div>
    <label htmlFor="email" className = "block text-sm font-medium text-gray-700 mb-1" >
      { t('register.email') }
      </label>
      <input
type = "email"
id = "email"
name = "email"
required
className = "w-full px-4 py-2 text-gray-900 bg-gray-100 rounded-md focus:ring-purple-600 focus:border-purple-600"
placeholder = { t('register.email') }
  />
  </div>
  <div >
  <label htmlFor="phone" className = "block text-sm font-medium text-gray-700 mb-1" >
    { t('register.phone') }
    </label>
    <input
type = "tel"
id = "phone"
name = "phone"
required
className = "w-full px-4 py-2 text-gray-900 bg-gray-100 rounded-md focus:ring-purple-600 focus:border-purple-600"
placeholder = { t('register.phone') }
  />
  </div>
  </div>

  <div >
  <label htmlFor="package" className = "block text-sm font-medium text-gray-700 mb-1" >
    { t('register.package') }
    </label>
    <select
id = "package"
name = "package"
required
className = "w-full px-4 py-2 text-gray-900 bg-gray-100 rounded-md focus:ring-purple-600 focus:border-purple-600"
  >
  <option value="" > { t('register.selectPackage') } </option>
    <option value = "basic" > { t('register.basic') } </option>
      <option value = "professional" > { t('register.professional') } </option>
        <option value = "integrated" > { t('register.integrated') } </option>
          </select>
          </div>

          <button
type = "submit"
className = "w-full bg-purple-600 text-white py-3 rounded-lg hover:bg-purple-700 transition-all whitespace-nowrap cursor-pointer"
  >
  { t('register.createAccount') }
  </button>
  </form>
  </div>
  </div>
  </div>
  </div>
  </section>

{/* Testimonials Section */ }
<section className="py-16 bg-gray-50" >
  <div className="container mx-auto px-4" >
    <div className="text-center mb-16" >
      <h2 className="text-3xl font-bold mb-4" > { t('testimonials.title') } </h2>
        <p className = "text-gray-600 max-w-2xl mx-auto" >
          { t('testimonials.description') }
          </p>
          </div>

          <div className = "grid grid-cols-1 md:grid-cols-3 gap-8" >
          {
            [
            {
              name: t('testimonials.customer1.name'),
              role: t('testimonials.customer1.role'),
              text: t('testimonials.customer1.text')
            },
            {
              name: t('testimonials.customer2.name'),
              role: t('testimonials.customer2.role'),
              text: t('testimonials.customer2.text')
            },
            {
              name: t('testimonials.customer3.name'),
              role: t('testimonials.customer3.role'),
              text: t('testimonials.customer3.text')
            }
            ].map((testimonial, index) => (
              <div key= { index } className = "bg-white p-6 rounded-lg shadow-sm" >
              <div className="flex items-center mb-4" >
            <div className="text-purple-600" >
            {
              [...Array(5)].map((_, i) => (
                <i key= { i } className = "ri-star-fill" > </i>
              ))
          }
            </div>
            </div>
            <p className = "text-gray-700 mb-6" > { testimonial.text } </p>
              <div className = "flex items-center" >
                <div className="w-12 h-12 bg-purple-100 rounded-full flex items-center justify-center text-purple-600 text-xl mr-4 rtl:mr-0 rtl:ml-4" >
                  <i className="ri-user-line" > </i>
                    </div>
                    <div >
                    <h3 className="font-semibold" > { testimonial.name } </h3>
                      <p className = "text-gray-600 text-sm" > { testimonial.role } </p>
                        </div>
                        </div>
                        </div>
            ))}
</div>
  </div>
  </section>

{/* Blog Section */ }
<section id="blog" className = "py-16 bg-white" >
  <div className="container mx-auto px-4" >
    <div className="text-center mb-16" >
      <h2 className="text-3xl font-bold mb-4" > { t('blog.title') } </h2>
        <p className = "text-gray-600 max-w-2xl mx-auto" >
          { t('blog.description') }
          </p>
          </div>

          <div className = "grid grid-cols-1 md:grid-cols-3 gap-8" >
          {
            [
            {
              image: 'https://readdy.ai/api/search-image?query=Modern%20gym%20interior%20with%20fitness%20equipment%20people%20working%20out%20bright%20lighting%20professional%20atmosphere%20high%20quality%20gym%20management&width=600&height=400&seq=1&orientation=landscape',
              date: 'May 13, 2025',
              author: t('blog.article1.author'),
              title: t('blog.article1.title'),
              description: t('blog.article1.description')
            },
            {
              image: 'https://readdy.ai/api/search-image?query=Fitness%20trainer%20helping%20client%20with%20workout%20plan%20on%20tablet%20gym%20management%20software%20interface%20visible%20professional%20gym%20environment&width=600&height=400&seq=2&orientation=landscape',
              date: 'May 10, 2025',
              author: t('blog.article2.author'),
              title: t('blog.article2.title'),
              description: t('blog.article2.description')
            },
            {
              image: 'https://readdy.ai/api/search-image?query=Business%20person%20analyzing%20gym%20financial%20data%20on%20computer%20screen%20charts%20and%20graphs%20showing%20membership%20growth%20professional%20office%20setting&width=600&height=400&seq=3&orientation=landscape',
              date: 'May 5, 2025',
              author: t('blog.article3.author'),
              title: t('blog.article3.title'),
              description: t('blog.article3.description')
            }
            ].map((article, index) => (
              <div key= { index } className = "rounded-lg overflow-hidden shadow-sm hover:shadow-xl transition-shadow" >
              <div className="h-48 overflow-hidden" >
            <img src={ article.image } alt = { article.title } className = "w-full h-full object-cover object-top" />
            </div>
            <div className = "p-6" >
            <div className="flex items-center text-sm text-gray-500 mb-3" >
            <div className="flex items-center mr-4 rtl:mr-0 rtl:ml-4" >
            <div className="w-4 h-4 flex items-center justify-center text-gray-500 mr-1 rtl:mr-0 rtl:ml-1" >
            <i className="ri-calendar-line" > </i>
            </div>
            <span > { article.date } </span>
            </div>
            <div className = "flex items-center" >
            <div className="w-4 h-4 flex items-center justify-center text-gray-500 mr-1 rtl:mr-0 rtl:ml-1" >
            <i className="ri-user-line" > </i>
            </div>
            <span > { article.author } </span>
            </div>
            </div>
            <h3 className = "text-xl font-semibold mb-3" > { article.title } </h3>
            <p className = "text-gray-600 mb-4" > { article.description } </p>
            <a href = "#" className = "text-purple-600 hover:underline flex items-center cursor-pointer" >
            <span>{ t('blog.readMore') } </span>
            <div className = "w-5 h-5 flex items-center justify-center ml-1 rtl:ml-0 rtl:mr-1" >
            <i className={`ri-arrow-${isRTL ? 'left' : 'right'}-line`} > </i>
            </div>
            </a>
            </div>
            </div>
            ))}
</div>

  <div className = "text-center mt-12" >
    <a href="/blog" className = "inline-block border border-purple-600 text-purple-600 px-8 py-3 rounded-lg hover:bg-purple-600 hover:text-white transition-all whitespace-nowrap cursor-pointer" >
      { t('blog.viewAll') }
      </a>
      </div>
      </div>
      </section>

{/* CTA Section */ }
<section className="py-16 bg-purple-600 text-white" >
  <div className="container mx-auto px-4" >
    <div className="text-center max-w-3xl mx-auto" >
      <h2 className="text-3xl font-bold mb-6" > { t('cta.title') } </h2>
        <p className = "text-white/90 mb-8 text-lg" >
          { t('cta.description') }
          </p>
          <a href = "#register" className = "inline-block bg-white text-purple-600 px-8 py-3 rounded-lg hover:bg-gray-100 transition-all whitespace-nowrap text-lg cursor-pointer" >
            { t('cta.button') }
            </a>
            </div>
            </div>
            </section>

{/* Footer */ }
<footer className="bg-gray-900 text-white pt-16 pb-8" >
  <div className="container mx-auto px-4" >
    <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-12" >
      <div>
      <a href="#" className = "text-3xl font-bold text-white mb-4 block" > 5vix </a>
        <p className = "text-gray-400 mb-6" >
          { t('footer.description') }
          </p>
          <div className = "flex flex-col space-y-3 mb-6" >
            <div className="flex items-center text-gray-400" >
              <div className="w-5 h-5 flex items-center justify-center mr-2 rtl:mr-0 rtl:ml-2" >
                <i className="ri-mail-line" > </i>
                  </div>
                  <a href = "mailto:info@5vix.com" className = "hover:text-white transition-colors" > info@5vix.com </a>
                    </div>
                    <div className = "flex items-center text-gray-400" >
                      <div className="w-5 h-5 flex items-center justify-center mr-2 rtl:mr-0 rtl:ml-2" >
                        <i className="ri-phone-line" > </i>
                          </div>
                          <a href = "tel:201044553254" className = "hover:text-white transition-colors" >01044553254 </a>
                            </div>
                            </div>
                            <div className = "flex space-x-4 rtl:space-x-reverse" >
                              <a href="https://www.tiktok.com/@5vixofficial" target = "_blank" rel = "noopener noreferrer" className = "w-10 h-10 flex items-center justify-center bg-gray-800 rounded-full hover:bg-pink-500 transition-colors cursor-pointer" >
                                <i className="ri-tiktok-fill text-white text-xl" > </i>
                                  </a>
                                  <a href = "https://www.youtube.com/@5vix-c3p" target = "_blank" rel = "noopener noreferrer" className = "w-10 h-10 flex items-center justify-center bg-gray-800 rounded-full hover:bg-red-600 transition-colors cursor-pointer" >
                                    <i className="ri-youtube-fill text-white text-xl" > </i>
                                      </a>
                                      <a href = "https://www.instagram.com/5vixofficial/" target = "_blank" rel = "noopener noreferrer" className = "w-10 h-10 flex items-center justify-center bg-gray-800 rounded-full hover:bg-pink-600 transition-colors cursor-pointer" >
                                        <i className="ri-instagram-fill text-white text-xl" > </i>
                                          </a>
                                          <a href = "https://www.linkedin.com/in/5vix-software-12058b363/" target = "_blank" rel = "noopener noreferrer" className = "w-10 h-10 flex items-center justify-center bg-gray-800 rounded-full hover:bg-blue-600 transition-colors cursor-pointer" >
                                            <i className="ri-linkedin-fill text-white text-xl" > </i>
                                              </a>
                                              </div>
                                              </div>

                                              <div >
                                              <h3 className="text-lg font-semibold mb-6" > { t('footer.quickLinks') } </h3>
                                                <ul className = "space-y-3" >
                                                  <li><a href="#home" className = "text-gray-400 hover:text-white transition-colors cursor-pointer" > { t('nav.home') } </a></li >
                                                    <li><a href="#services" className = "text-gray-400 hover:text-white transition-colors cursor-pointer" > { t('nav.services') } </a></li >
                                                      <li><a href="#register" className = "text-gray-400 hover:text-white transition-colors cursor-pointer" > { t('nav.register') } </a></li >
                                                        <li><a href="#blog" className = "text-gray-400 hover:text-white transition-colors cursor-pointer" > { t('nav.blog') } </a></li >
                                                          </ul>
                                                          </div>

                                                          <div >
                                                          <h3 className="text-lg font-semibold mb-6" > { t('footer.support') } </h3>
                                                            <ul className = "space-y-3" >
                                                              <li><a href="/help-center" className = "text-gray-400 hover:text-white transition-colors cursor-pointer" > { t('footer.helpCenter') } </a></li >
                                                                <li><a href="/help-center" className = "text-gray-400 hover:text-white transition-colors cursor-pointer" > { t('footer.faq') } </a></li >
                                                                  <li><a href="tel:201044553254" className = "text-gray-400 hover:text-white transition-colors cursor-pointer" > { t('footer.contactUs') } </a></li >
                                                                    <li><a href="/terms" className = "text-gray-400 hover:text-white transition-colors cursor-pointer" > { t('footer.terms') } </a></li >
                                                                      <li><a href="/privacy" className = "text-gray-400 hover:text-white transition-colors cursor-pointer" > { t('footer.privacy') } </a></li >
                                                                        </ul>
                                                                        </div>

                                                                        <div >
                                                                        <h3 className="text-lg font-semibold mb-6" > { t('footer.newsletter') } </h3>
                                                                          <p className = "text-gray-400 mb-4" > { t('footer.newsletterDesc') } </p>
                                                                            <form className = "mb-4" >
                                                                              <div className="flex" >
                                                                                <input
      type="email"
placeholder = { t('register.email') }
className = "bg-gray-800 text-white px-4 py-2 rounded-s-lg focus:outline-none focus:ring-2 focus:ring-purple-600 flex-1"
  />
  <button className="bg-purple-600 text-white px-4 py-2 rounded-e-lg hover:bg-purple-700 transition-all whitespace-nowrap cursor-pointer" >
    { t('footer.subscribe') }
    </button>
    </div>
    </form>
    <div className = "flex items-center space-x-3 rtl:space-x-reverse" >
      <div className="w-8 h-8 flex items-center justify-center" >
        <i className="ri-visa-fill text-2xl text-gray-300" > </i>
          </div>
          <div className = "w-8 h-8 flex items-center justify-center" >
            <i className="ri-mastercard-fill text-2xl text-gray-300" > </i>
              </div>
              <div className = "w-8 h-8 flex items-center justify-center" >
                <i className="ri-paypal-fill text-2xl text-gray-300" > </i>
                  </div>
                  <div className = "w-8 h-8 flex items-center justify-center" >
                    <i className="ri-apple-fill text-2xl text-gray-300" > </i>
                      </div>
                      </div>
                      </div>
                      </div>

                      <div className = "border-t border-gray-800 pt-8" >
                        <div className="flex flex-col md:flex-row justify-between items-center" >
                          <p className="text-gray-400 mb-4 md:mb-0" > { t('footer.copyright') } </p>
                            <div className = "flex space-x-4 rtl:space-x-reverse" >
                              <a href="/terms" className = "text-gray-400 hover:text-white transition-colors cursor-pointer" > { t('footer.terms') } </a>
                                <a href = "/privacy" className = "text-gray-400 hover:text-white transition-colors cursor-pointer" > { t('footer.privacy') } </a>
                                  <a href = "/privacy" className = "text-gray-400 hover:text-white transition-colors cursor-pointer" > { t('footer.cookies') } </a>
                                    </div>
                                    </div>
                                    </div>
                                    </div>
                                    </footer>
                                    </div>
  );
}
